import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ResumeModalites } from './ResumeModalites';
import {
    useRoutes,
    Routes,
    IResumeOffre,
    isVariableProtege,
    ISession,
    hasSoumissionAssurance
} from '../../hooks';
import {
    sendEvent,
    EVENT_CATEGORIES,
    EVENT_ACTIONS,
    EVENT_LABELS
} from '../../features';
import { isFrequenceEqual } from '../../utils';

export interface IResumeModalitesConnectedProps {
    isEditButtonDisplayed: boolean;
    session: ISession;
    resumeOffre: IResumeOffre;
}

export const ResumeModalitesConnected: React.FC<
    IResumeModalitesConnectedProps
> = ({ isEditButtonDisplayed, session, resumeOffre }) => {
    const dispatch = useDispatch();
    const { goToRoute } = useRoutes();

    // State
    const [shouldEditButtonBeDisplayed, setShouldEditButtonBeDisplayed] =
        useState(null);

    // Store
    const isLoading = useSelector((state: any) => state.loading.show);
    const offreBase = useSelector((state: any) => state.modalites.offreBase);
    const offreChoisie = useSelector(
        (state: any) => state.modalites.offreChoisie
    );

    const handleOnModifiedClick = () => {
        dispatch(
            sendEvent({
                category: EVENT_CATEGORIES.RHN,
                action: EVENT_ACTIONS.CLIC,
                label: EVENT_LABELS.MODIFIER + 'modalités de paiement'
            })
        );

        goToRoute(Routes.MODALITES);
    };

    useEffect(() => {
        if (session && resumeOffre) {
            setShouldEditButtonBeDisplayed(
                isEditButtonDisplayed &&
                    session?.contexteToggleFeature.calculScenarioPaiement ===
                        true &&
                    !session?.isMartine &&
                    !isVariableProtege(resumeOffre?.offreChoisie) &&
                    !hasSoumissionAssurance(
                        resumeOffre?.assurance?.codeAssurance
                    )
            );
        }
    }, [session, resumeOffre]);

    return (
        !isLoading && (
            <ResumeModalites
                isEditButtonDisplayed={shouldEditButtonBeDisplayed}
                isFrequenceModifiee={
                    // si offreBase est null c'est que le membre a skip la page de modalites (ex: quitte le parcours et reviens)
                    offreBase
                        ? !isFrequenceEqual(
                              offreChoisie?.frequenceRemboursement,
                              offreBase?.frequenceRemboursement
                          )
                        : resumeOffre?.offreChoisie
                              ?.dateDebutEffetChangementFrequence !== null
                }
                resumeOffre={resumeOffre}
                onModifiedClick={handleOnModifiedClick}
            />
        )
    );
};
